'use strict';
const angular = require('angular');

export default angular.module('conduuApp.html5vfix', [])
  .directive('html5vfix', function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        $timeout(() => {
          attrs.$set('src', attrs.videosource);

          let elmVideo = element.parent();

          elmVideo[0].load();
          elmVideo[0].play();
        });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/html5vfix/html5vfix.directive.js